import OriginTracing from '@atlassiansox/origin-tracing';
import differenceInDays from 'date-fns/differenceInDays';

/**
 * Add origin to the payment flow experience URL. Prefer V2 URL over V1.
 * @param paymentExperienceUrlV1 Payment flow experience URL V1
 * @param paymentExperienceUrlV2 Payment flow experience URL V2
 * @returns Payment flow experience URL with origin added
 */
export const addOriginToPaymentFlowUrl = ({
	paymentExperienceUrlV1,
	paymentExperienceUrlV2,
}: {
	paymentExperienceUrlV1?: string;
	paymentExperienceUrlV2?: string;
}): string | undefined => {
	const experienceUrl = paymentExperienceUrlV2 || paymentExperienceUrlV1;

	if (!experienceUrl) {
		return undefined;
	}

	const origin = new OriginTracing({ product: 'confluence' });

	return origin.addToUrl(experienceUrl);
};

/**
 * Get the number of days left in the trial
 * @param endTimestamp End timestamp of the trial
 * @returns Number of days left in the trial
 */
export const getTrialEndDate = (endTimestamp?: number): number | undefined => {
	if (!endTimestamp) {
		return undefined;
	}

	return differenceInDays(new Date(endTimestamp), new Date()) + 1;
};
